import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "filterTab"]

  connect() {
    this.currentFilter = "unread"
    this.polling = setInterval(() => this.pollBadge(), 30000)
    this.boundClose = this.closeOnOutsideClick.bind(this)
    document.addEventListener("click", this.boundClose)
  }

  disconnect() {
    if (this.polling) clearInterval(this.polling)
    document.removeEventListener("click", this.boundClose)
  }

  toggle(event) {
    event.stopPropagation()
    const isHidden = this.panelTarget.classList.contains("hidden")
    this.panelTarget.classList.toggle("hidden")
    if (isHidden) {
      this.currentFilter = "unread"
      this.updateFilterTabs()
      this.refreshList()
    }
  }

  switchFilter(event) {
    event.stopPropagation()
    const filter = event.currentTarget.dataset.filter
    if (filter === this.currentFilter) return

    this.currentFilter = filter
    this.updateFilterTabs()
    this.refreshList()
  }

  updateFilterTabs() {
    this.filterTabTargets.forEach(tab => {
      const isActive = tab.dataset.filter === this.currentFilter
      if (isActive) {
        tab.classList.add("border-blue-500", "text-blue-600")
        tab.classList.remove("border-transparent", "text-gray-500")
      } else {
        tab.classList.remove("border-blue-500", "text-blue-600")
        tab.classList.add("border-transparent", "text-gray-500")
      }
    })
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.panelTarget.classList.add("hidden")
    }
  }

  async pollBadge() {
    try {
      const response = await fetch("/notifications?badge_only=true", {
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        }
      })
      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      }
    } catch (e) {
      // Silently ignore polling errors
    }
  }

  async refreshList() {
    try {
      const response = await fetch(`/notifications?filter=${this.currentFilter}`, {
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        }
      })
      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      }
    } catch (e) {
      // Silently ignore refresh errors
    }
  }
}
